<div class="speedometer-container {{ size() }}">
  <div class="speedometer">
    <div class="reading low" [style.transform]="'rotate(' + lowSpeed() + 'deg)'"></div>
    <div class="reading medium" [style.transform]="'rotate(' + mediumSpeed() + 'deg)'"></div>
    <div class="reading high" [style.transform]="'rotate(' + highSpeed() + 'deg)'"></div>
    <div class="reading critical" [style.transform]="'rotate(' + criticalSpeed() + 'deg)'"></div>
    <div class="reading-base"></div>
    <div class="centre-circle">
      <span [style.transform]="'rotate(' + needleSpeed() + 'deg)'"></span>
    </div>
    <div class="base"></div>
  </div>
  <div [class]="Severity.speedometerClassName(severity())">
    {{ Severity.name(severity()) | translate }}
  </div>
</div>
